import React from "react"
import classNames from "classnames"
import { useParams } from "react-router-dom"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"

const DataQualityDatacenterInternalChartOrganism = () => {
  const { pillarId: urlPillarId } = useParams()

  return (
    <div className="Verdikt-Score">
      <div className={classNames(urlPillarId, "page-frame")}>
        <div className={classNames("page")}>
          <div
            className={classNames(
              urlPillarId,
              "widget",
              "chart",
              "transparent-widget"
            )}
          >
            <MetabaseChartMolecule
              verdikt_alias={"dashboard_dataquality_datacenter_internal"}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DataQualityDatacenterInternalChartOrganism
